import { IPromotionLogic } from '@gongxigames/framework/promotions';

export interface ILogicPromotionFunctional {
    getPromotion<LogicPromotion extends IPromotionLogic>(): LogicPromotion;
}
